import React from 'react';
import MultiSelectInput from '../../components/MultiSelectInput/MultiSelectInput';

// Tipuri de alerte specifice monitorizării achizițiilor publice (SEAP) —
// construcții. Cheile sunt stabile (persistate); etichetele și descrierile
// sunt în română și reflectă fluxul real al platformei Licitatii-Constructii.
const ALERT_TYPE_OPTIONS = [
  'NewTenderByCpv',
  'NewTenderByCounty',
  'WatchedProcedureChange',
  'WatchedProcedureAward',
  'NewIntentByAuthority',
  'NewTenderAboveThreshold',
  'DailyDigest',
  'PlatformAnnouncement',
];

const getAlertTypeDisplayName = (type) => {
  const displayNames = {
    NewTenderByCpv: 'Licitație nouă pe coduri CPV monitorizate',
    NewTenderByCounty: 'Licitație nouă în județele monitorizate',
    WatchedProcedureChange:
      'Modificare termen sau documentație la o procedură urmărită',
    WatchedProcedureAward:
      'Anunț de atribuire publicat pentru o procedură urmărită',
    NewIntentByAuthority: 'Anunț de intenție nou pentru autorități urmărite',
    NewTenderAboveThreshold: 'Procedură nouă peste valoarea-prag setată',
    DailyDigest: 'Rezumat zilnic (digest)',
    PlatformAnnouncement:
      'Anunț important de la echipa Licitatii-Constructii.ro',
  };
  return displayNames[type] || type;
};

const getAlertTypeDescription = (type) => {
  const descriptions = {
    NewTenderByCpv:
      'Notificare când apare o licitație nouă pe SEAP având un cod CPV din lista ta monitorizată.',
    NewTenderByCounty:
      'Notificare când apare o licitație nouă într-unul din județele pe care le-ai setat ca zonă de interes.',
    WatchedProcedureChange:
      'Notificare la modificarea termenului-limită, a documentației sau a clarificărilor pentru o procedură pe care o urmărești.',
    WatchedProcedureAward:
      'Notificare când se publică anunțul de atribuire (câștigător, valoare contract) pentru o procedură urmărită.',
    NewIntentByAuthority:
      'Notificare când o autoritate contractantă monitorizată publică un anunț de intenție pentru o achiziție viitoare.',
    NewTenderAboveThreshold:
      'Notificare când apare o procedură a cărei valoare estimată depășește pragul setat de tine (RON).',
    DailyDigest:
      'Un singur email pe zi cu rezumatul tuturor licitațiilor noi și actualizărilor relevante pentru criteriile tale.',
    PlatformAnnouncement:
      'Anunțuri operaționale de la echipa Licitatii-Constructii.ro: mentenanță, schimbări majore, oportunități.',
  };
  return descriptions[type] || 'Descriere indisponibilă';
};

const EmailAlerts = ({
  userData,
  setUserData,
  emailAlertsEdit,
  setEmailAlertsEdit,
  handleEmailAlertsSave,
}) => {
  return (
    <div className="p-6 grid bg-white shadow-md rounded-lg col-span-1">
      <h2 className="text-2xl font-bold border-b-2 pb-2 mb-4">
        Alerte pe Email
      </h2>
      {emailAlertsEdit ? (
        <div>
          <div className="mb-4">
            <label className="block mb-2">Primește alerte pe email:</label>
            <label className="flex items-center gap-3 p-3 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
              <input
                type="checkbox"
                checked={userData?.emailAlerts || false}
                onChange={(e) =>
                  setUserData((prev) => ({
                    ...prev,
                    emailAlerts: e.target.checked,
                  }))
                }
                className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="text-sm text-gray-700">
                {userData?.emailAlerts
                  ? '🔔 Activă - primesc notificări pe email'
                  : '🔕 Inactivă - nu primesc notificări'}
              </span>
            </label>
          </div>

          {/* Tipuri de alerte cu MultiSelectInput */}
          <div className="mb-6">
            <MultiSelectInput
              label="Tipuri de alerte"
              placeholder="Selectează tipurile de alerte dorite..."
              values={userData?.alertTypes || []}
              onChange={(selectedTypes) =>
                setUserData((prev) => ({
                  ...prev,
                  alertTypes: selectedTypes,
                }))
              }
              suggestions={ALERT_TYPE_OPTIONS}
              renderOption={(opt) => getAlertTypeDisplayName(opt)}
              allowCustom={false}
            />

            {/* Descrieri pentru fiecare tip de alertă */}
            {userData?.alertTypes && userData.alertTypes.length > 0 && (
              <div className="mt-3 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <h4 className="text-sm font-medium text-blue-800 mb-2">
                  📋 Descrierea alertelor selectate:
                </h4>
                <ul className="space-y-1 text-sm text-blue-700">
                  {userData.alertTypes.map((type) => (
                    <li key={type} className="flex items-start gap-2">
                      <span className="text-blue-500 mt-0.5">•</span>
                      <span>
                        <strong>{getAlertTypeDisplayName(type)}:</strong>{' '}
                        {getAlertTypeDescription(type)}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleEmailAlertsSave}
              className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition-colors font-medium shadow-sm"
            >
              💾 Salvează Preferințele
            </button>
            <button
              onClick={() => setEmailAlertsEdit(false)}
              className="flex items-center gap-2 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors font-medium"
            >
              ❌ Anulează
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
              <span className="text-2xl">
                {userData?.emailAlerts ? '🔔' : '🔕'}
              </span>
              <div>
                <p className="font-medium text-gray-900">
                  Status alerte email:{' '}
                  <span
                    className={`${userData?.emailAlerts ? 'text-green-600' : 'text-gray-500'}`}
                  >
                    {userData?.emailAlerts ? 'ACTIVATE' : 'DEZACTIVATE'}
                  </span>
                </p>
                <p className="text-sm text-gray-600">
                  {userData?.emailAlerts
                    ? 'Primiți notificări pe email pentru evenimentele selectate'
                    : 'Nu primiți notificări pe email'}
                </p>
              </div>
            </div>

            <div className="p-4 border border-gray-200 rounded-lg">
              <h3 className="font-medium text-gray-900 mb-3 flex items-center gap-2">
                📧 Tipuri de alerte configurate:
              </h3>
              {userData?.alertTypes?.length ? (
                <div className="space-y-2">
                  {userData.alertTypes.map((type, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-3 p-2 bg-indigo-50 rounded-lg"
                    >
                      <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
                      <div>
                        <span className="font-medium text-indigo-800">
                          {getAlertTypeDisplayName(type)}
                        </span>
                        <p className="text-sm text-indigo-600">
                          {getAlertTypeDescription(type)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-6 text-gray-500">
                  <span className="text-4xl block mb-2">📭</span>
                  <p className="font-medium">Nicio alertă selectată</p>
                  <p className="text-sm">
                    Faceți clic pe "Modifică" pentru a configura alertele
                  </p>
                </div>
              )}
            </div>
          </div>

          <button
            onClick={() => setEmailAlertsEdit(true)}
            className="mt-6 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition-colors font-medium shadow-sm"
          >
            ⚙️ Modifică Preferințele
          </button>
        </div>
      )}
    </div>
  );
};

export default EmailAlerts;
